import React from "react";
import {Button} from "primereact/button";
import useProject from "../../hooks/useProject";
import {Link} from "react-router-dom";

const ProjectsListItemCard = ({project}) => {
  const {deleteProject, projectEditHandler} = useProject();
  console.log(project);
  return (
    <div className="col-12 md:col-6 lg:col-4">
      <div
        className="surface-card shadow-2 border-rounded p-3"
        style={{borderRadius: "6px"}}>
        <div className="flex justify-content-between align-items-start">
          <div>
            <div className="text-xl font-medium text-green-500 mb-2">{project.name}</div>
            <p className="mt-0 mb-3 text-600">{project.brief}</p>
          </div>
          <Link to={`/auth/projects/edit/${project.id}`}>
            <Button
              onClick={() => projectEditHandler(project.id)}
              icon="pi pi-pencil"
              className="p-button p-button-text p-button-icon-only bg-blue-100
              border-round"></Button>
          </Link>
        </div>
        <img
          src={project.img}
          className="mb-3 w-full"
        />
        <ul className="list-none m-0 p-0">
          <li className="px-0 py-2 flex justify-content-between align-items-center border-bottom-1 surface-border">
            <span className="text-600 font-medium text-sm">Creat</span>
            <span className="text-900 font-medium text-sm">{project.likes}</span>
          </li>
          <li className="px-0 py-2 flex justify-content-between align-items-center border-bottom-1 surface-border">
            <span className="text-600 font-medium text-sm">Modificat</span>
            <span className="text-900 font-medium text-sm">{project.likes}</span>
          </li>
        </ul>
        <div className="flex justify-content-between pt-3">
          <Button
            onClick={() => deleteProject(project.id)}
            // label="Sterge"
            icon="pi pi-trash"
            className="p-button-text p-button-secondary bg-red-100 w-4 ml-2"
          />
          <Button
            onClick={() => projectEditHandler(project.id)}
            // label="Detalii"
            icon="pi pi-database"
            className="p-button-text p-button-secondary bg-gray-100 w-4 mr-2"
          />
        </div>
      </div>
    </div>
  );
};
export default ProjectsListItemCard;
